import { convertFlagsObjectToArray } from 'utils/misc';

import { DutyCodeFormValues } from '../type';
import { CreateDutyCodeRequest, DutyCodeFlag } from 'generated/index';

export const convertToDutyCodeRequest = (
  data: DutyCodeFormValues
): CreateDutyCodeRequest => {
  return {
    validFrom: data.validFrom.toISOString(),
    validTo: data.validTo.toISOString(),
    code: data.displayDutyCode,
    colorCode: data.colorCode,
    description: data.description,
    flags: convertFlagsObjectToArray(data.flags) as DutyCodeFlag[],
    periods: data.periods
  };
};
